import { FormattedField, MessagePart } from '@core/services/gbe-error-parser/warning.model';

/** A finding as a reader sees it: its sentence, and every payload value it carries. */
export interface PresentedFinding {
  body: string;
  parts?: MessagePart[];
  payload: FormattedField[];
}

/**
 * What a changed finding was: the old value of each payload field that changed, labelled. A change
 * no payload value shows, such as a stop that moved, falls back to the old sentence, and to nothing
 * when even that reads the same. `show` renders a field's value, as the row it explains does.
 */
export function previousOf(
  now: PresentedFinding,
  before: PresentedFinding,
  show: (field: FormattedField) => string = (field) => field.value
): string | null {
  const current = new Map(now.payload.map((field) => [field.key, field]));
  // A display that rounds both values alike would read "2 h 36 m (was 2 h 36 m)".
  const shownApart = (field: FormattedField): string => {
    const shown = show(field);
    const nowField = current.get(field.key);
    return nowField !== undefined && show(nowField) === shown ? field.value : shown;
  };
  const changed = before.payload.filter(
    (field) => current.get(field.key)?.value !== field.value
  );
  if (changed.length > 0) {
    return changed.map((field) => `${field.label} ${shownApart(field)}`).join(', ');
  }
  return before.body === now.body ? null : before.body;
}
